var _circle, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 14.667,
  fill: "#fff",
  opacity: 0.2
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "Profile_svg__a",
  width: 30,
  height: 30,
  x: 1,
  y: 1,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 14.667,
  fill: "#636F7A"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Profile_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.378 15.173a4.933 4.933 0 0 0 4.927 4.927 4.933 4.933 0 0 0 4.927-4.927 4.933 4.933 0 0 0-4.927-4.927 4.933 4.933 0 0 0-4.927 4.927m13.687 15.876h1.095v-1.095c0-4.225-3.44-7.664-7.665-7.664h-4.38c-4.226 0-7.664 3.439-7.664 7.664v1.095z"
}))));
export { SvgProfile as ReactComponent };
export default __webpack_public_path__ + "Profile.f8fbba27.svg";